import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const BrandServiceLinks = ({ brand }) => {
  const rawBrand = String(brand || "").trim();
  const normalizedBrand = rawBrand.toLowerCase();
  const brandLabel =
    normalizedBrand === "lg"
      ? "LG"
      : normalizedBrand === "ifb"
      ? "IFB"
      : rawBrand.charAt(0).toUpperCase() + rawBrand.slice(1);
  const brandSlug = String(brand || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-");

  const getDescription = (label) => {
    const title = label.toLowerCase();

    if (title.includes("not cooling")) {
      return "Fast cooling diagnosis and repair for refrigerator performance issues";
    }

    if (title.includes("gas leakage")) {
      return "Leak inspection, sealing support, and gas charging assistance";
    }

    if (title.includes("compressor")) {
      return "Compressor inspection and repair guidance from trained technicians";
    }

    if (title.includes("not spinning")) {
      return "Spin cycle troubleshooting for drum, belt, and motor faults";
    }

    if (title.includes("water leak")) {
      return "Leakage checks for inlet, outlet, pipe, and drainage issues";
    }

    if (title.includes("no power") || title.includes("not working")) {
      return "Power, wiring, panel, and startup fault diagnosis at your doorstep";
    }

    if (title.includes("noise") || title.includes("drum")) {
      return "Noise, vibration, bearing, and drum movement support";
    }

    if (title.includes("ac")) {
      return "AC service, inspection, and repair support for better cooling";
    }

    return `Professional doorstep ${label.toLowerCase()} in Bangalore`;
  };

  const sections = [
    {
      title: `${brandLabel} Washing Machine`,
      links: [
        {
          label: `${brandLabel} Washing Machine Service`,
          to: `/${brandSlug}-washing-machine-service-bangalore`,
        },
        {
          label: `${brandLabel} Washing Machine Repair`,
          to: `/${brandSlug}-washing-machine-repair-bangalore`,
        },
        {
          label: `${brandLabel} Washing Machine Not Spinning`,
          to: `/${brandSlug}-washing-machine-not-spinning`,
        },
        {
          label: `${brandLabel} Washing Machine Not Working Repair`,
          to: `/${brandSlug}-washing-machine-not-working-repair`,
        },
        {
          label: `${brandLabel} Washing Machine Water Leak Repair`,
          to: `/${brandSlug}-washing-machine-water-leak-repair`,
        },
        {
          label: `${brandLabel} Washing Machine No Power Issue`,
          to: `/${brandSlug}-washing-machine-no-power-issue`,
        },
        {
          label: `${brandLabel} Washing Machine Noise Problem`,
          to: `/${brandSlug}-washing-machine-noise-problem`,
        },
        {
          label: `${brandLabel} Washing Machine Drum Repair`,
          to: `/${brandSlug}-washing-machine-drum-repair`,
        },
      ],
    },
    {
      title: `${brandLabel} Refrigerator`,
      links: [
        {
          label: `${brandLabel} Fridge Service`,
          to: `/${brandSlug}-fridge-service-bangalore`,
        },
        {
          label: `${brandLabel} Fridge Not Cooling`,
          to: `/${brandSlug}-fridge-not-cooling`,
        },
        {
          label: `${brandLabel} Fridge Gas Leakage`,
          to: `/${brandSlug}-fridge-gas-leakage`,
        },
        {
          label: `${brandLabel} Fridge Compressor Repair`,
          to: `/${brandSlug}-fridge-compressor-repair`,
        },
        {
          label: `Single Door Fridge`,
          to: "/single-door-fridge-service-bangalore",
        },
        {
          label: `Double Door Refrigerator`,
          to: "/double-door-refrigerator-service-bangalore",
        },
        {
          label: `Side-by-Side Fridge`,
          to: "/side-by-side-fridge-service-bangalore",
        },
        {
          label: `Mini Fridge`,
          to: "/mini-fridge-service-bangalore",
        },
      ],
    },
    {
      title: `Other ${brandLabel} Appliances`,
      links: [
        {
          label: `${brandLabel} Appliance Service Home`,
          to: `/${brandSlug}-appliance-service-bangalore`,
        },
        {
          label: `${brandLabel} AC Service`,
          to: `/${brandSlug}-ac-service-bangalore`,
        },
        {
          label: `Other ${brandLabel} Services`,
          to: `/${brandSlug}-other-services-bangalore`,
        },
      ],
    },
  ];

  return (
    <>
      {sections.map((section) => (
        <section className="brand-services-section" key={section.title}>
          <div className="brand-service-list-header">
            <span>{section.title}</span>
          </div>

          <div className="brand-service-links-grid">
            {section.links.map((link) => (
              <Link
                key={link.label}
                to={link.to}
                className="brand-service-link-card"
              >
                <span className="brand-service-card-title">{link.label}</span>
                <span className="brand-service-card-desc">
                  {getDescription(link.label)}
                </span>
                <span className="brand-service-card-action">
                  View Details <ArrowRight size={18} strokeWidth={2.4} />
                </span>
              </Link>
            ))}
          </div>
        </section>
      ))}
    </>
  );
};

export default BrandServiceLinks;
